import { render } from "./servicehistories.vue?vue&type=template&id=c2aa45d0&scoped=true&ts=true"
import script from "./servicehistories.vue?vue&type=script&lang=ts"
export * from "./servicehistories.vue?vue&type=script&lang=ts"

import "./servicehistories.vue?vue&type=style&index=0&id=c2aa45d0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2aa45d0"]])

export default __exports__